module.exports = __webpack_public_path__ + "static/img/restaurant-filter-icon04.74ece5ad.svg";